import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Layout, Title, Label, Radio, Checkbox, Icon } from '~ui';
import CollectionIcon from '~co/collections/item/icon';

export default function SettingsExtensionAdd() {
  const add_default_collection = useSelector(
    (state) => state.config.add_default_collection,
  );
  const add_auto_save = useSelector((state) => state.config.add_auto_save);
  const browser_extension_mode = useSelector(
    (state) => state.config.browser_extension_mode,
  );
  const dispatch = useDispatch();

  if (browser_extension_mode != 'clipper') return null;

  return (
    <>
      <Title>{t.s('clipperSettings')}</Title>

      <Layout type='grid'>
        <Label>{t.s('newBookmark')}</Label>
        <Checkbox
          checked={add_auto_save}
          onChange={() => dispatch(set('add_auto_save', !add_auto_save))}
        >
          {t.s('saveAutomatically')}
        </Checkbox>

        <Label>{t.s('defaultCollection')}</Label>
        <div>
          {[
            [-1, t.s('defaultCollection--1'), <CollectionIcon _id={-1} />],
            [0, t.s('lastUsed'), <Icon name='sort_-created' />],
          ].map(([key, title, icon]) => (
            <Radio
              key={key}
              checked={add_default_collection == key}
              name='add_default_collection'
              onChange={() => dispatch(set('add_default_collection', key))}
            >
              {icon}
              {title}
            </Radio>
          ))}
        </div>
      </Layout>
    </>
  );
}
